import { render, staticRenderFns } from "./StepFood.vue?vue&type=template&id=6371d492"
import script from "./StepFood.vue?vue&type=script&lang=js"
export * from "./StepFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports